<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12>
				<app-datatable :title="$t('Payments datatable')" :endpoint="endpoint" :data="data" :headers="headers"
					:filter="filter" @onView="viewItem" :hasView="true" :hasEdit="false" :hasDelete="false">
					<template v-slot:[`item.state`]="{ item }">
						<v-chip :color="item.state_color" dark>
							{{ item.state_label }}
						</v-chip>
					</template>
					<template v-slot:[`item.active`]="{ item }">
						<app-active-button v-model="item.active"></app-active-button>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>

		<app-create-fab-button @click="$inertia.visit($route('central.payments.create'))"></app-create-fab-button>

		<app-delete-dialog ref="deleteDialog" :endpoint="'central.payments.destroy'" :uuid="item.uuid">
		</app-delete-dialog>
	</v-container>
</template>

<script>
import pickBy from "lodash/pickBy";
export default {
	props: ["data", "customers", "memberships"],
	data() {
		return {
			filter: {},
			item: {},
		};
	},
	computed: {
		endpoint() {
			return this.$route("central.payments.index");
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					sortable: false,
					searchable: false,
					align: "left",
					width: 80,
				},
				{
					text: this.$t("label.datetime"),
					value: "created_at",
					align: "start",
					sortable: false,
					width: 200,
				},
				{
					text: this.$t("Code"),
					value: "code",
					align: "start",
					sortable: false,
				},
				{
					text: this.$t("Amount"),
					value: "amount",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Description"),
					value: "description",
					align: "start",
					sortable: false,
				},
				{
					text: this.$t("Payment method"),
					value: "method",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("label.state"),
					value: "state",
					sortable: false,
					searchable: false,
					width: 150,
					align: "end",
				},
			];
		},
	},

	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},

		viewItem(item) {
			this.$inertia.visit(this.$route("central.payments.show", item.uuid));
		},
	},
};
</script>